(function injectTysonsMobileInteractionStyles() {
  if (typeof document === 'undefined' || document.getElementById('tts-mobile-interaction-runtime-fix')) return;
  var style = document.createElement('style');
  style.id = 'tts-mobile-interaction-runtime-fix';
  style.textContent = '@media screen and (max-width: 749px) { :root, .theme-scheme, [class*="scheme"], [data-color-scheme] { --color-scheme-accent-1: 7 73 118 !important; --color-scheme-accent-1-contrast: 255 255 255 !important; --color-scheme-accent-2: 7 73 118 !important; --color-scheme-accent-2-contrast: 255 255 255 !important; } html, body { background: #fefaf5 !important; background-color: #fefaf5 !important; } *, *::before, *::after { -webkit-tap-highlight-color: rgba(7, 73, 118, 0.14) !important; caret-color: #074976; } *:focus, *:focus-visible, input:focus, textarea:focus, select:focus, button:focus, a:focus { outline-color: rgba(7, 73, 118, 0.65) !important; box-shadow: 0 0 0 2px rgba(7, 73, 118, 0.16) !important; } a:active, button:active, summary:active, label:active, [role="button"]:active, .push-btn:active, .push-btn__surface:active { --tw-ring-color: rgba(7, 73, 118, 0.22) !important; --tw-ring-offset-color: #fefaf5 !important; border-color: #074976 !important; } ::selection { background: rgba(7, 73, 118, 0.2) !important; color: #003a5d !important; } }';
  (document.head || document.documentElement).appendChild(style);
})();

(function () {
  'use strict';

  const tiers = [
    { threshold: 3900, variantId: 43616650362947, title: 'Free Random Beyblade', label: 'Spend $39+' },
    { threshold: 6500, variantId: 43616650395715, title: 'Free Launcher', label: 'Spend $65+' },
    { threshold: 12500, variantId: 43616650428483, title: 'Free 4-Pack & Launcher', label: 'Spend $125+' },
    { threshold: 18900, variantId: 43616650461251, title: 'Free Mini Stadium', label: 'Spend $189+' }
  ];
  const giftVariantIds = new Set(tiers.map((tier) => tier.variantId));
  const sectionIds = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  let syncing = false;
  let debounceTimer = null;

  function setImportant(element, property, value) {
    if (element && element.style) element.style.setProperty(property, value, 'important');
  }

  function keepMobileRewardPanelContained(panel) {
    if (!panel || !window.matchMedia || !window.matchMedia('(max-width: 640px)').matches) return;
    const grid = panel.querySelector('.tts-free-gift-tier-grid');
    const header = panel.querySelector('.tts-free-gift-header');
    const title = panel.querySelector('.tts-free-gift-eyebrow');
    const message = panel.querySelector('.tts-free-gift-message');
    const track = panel.querySelector('.tts-free-gift-track');
    const form = panel.closest('cart-items, .cart-drawer, .drawer, .cart__items, .cart__contents') || panel.parentElement;
    const cartContents = form ? form.querySelector('form, .cart__contents, .cart-items, [data-cart-items]') : null;
    const followingBlock = panel.nextElementSibling;

    setImportant(panel, 'box-sizing', 'border-box');
    setImportant(panel, 'display', 'block');
    setImportant(panel, 'height', 'auto');
    setImportant(panel, 'min-height', '220px');
    setImportant(panel, 'overflow', 'hidden');
    setImportant(panel, 'position', 'relative');
    setImportant(panel, 'z-index', '3');
    setImportant(panel, 'padding', '8px');
    setImportant(panel, 'margin-bottom', '18px');
    setImportant(header, 'display', 'flex');
    setImportant(header, 'align-items', 'flex-start');
    setImportant(header, 'justify-content', 'space-between');
    setImportant(header, 'gap', '7px');
    setImportant(title, 'font-size', '11px');
    setImportant(title, 'line-height', '1.08');
    setImportant(title, 'max-width', '38%');
    setImportant(message, 'font-size', '9px');
    setImportant(message, 'line-height', '1.12');
    setImportant(message, 'max-width', '58%');
    setImportant(message, 'text-align', 'right');
    setImportant(grid, 'box-sizing', 'border-box');
    setImportant(grid, 'display', 'grid');
    setImportant(grid, 'grid-template-columns', 'repeat(2, minmax(0, 1fr))');
    setImportant(grid, 'gap', '5px');
    setImportant(grid, 'position', 'static');
    setImportant(grid, 'width', '100%');
    setImportant(grid, 'min-height', '0');
    setImportant(track, 'display', 'block');
    setImportant(track, 'position', 'static');
    setImportant(track, 'height', '7px');
    setImportant(track, 'margin-top', '7px');

    panel.querySelectorAll('.tts-free-gift-tier').forEach((tier) => {
      setImportant(tier, 'box-sizing', 'border-box');
      setImportant(tier, 'position', 'static');
      setImportant(tier, 'min-height', '66px');
      setImportant(tier, 'padding', '5px 4px');
      setImportant(tier, 'display', 'grid');
      setImportant(tier, 'align-content', 'center');
      setImportant(tier, 'gap', '1px');
      setImportant(tier.querySelector('span'), 'font-size', '8px');
      setImportant(tier.querySelector('strong'), 'font-size', '13px');
      setImportant(tier.querySelector('em'), 'font-size', '8px');
      setImportant(tier.querySelector('em'), 'line-height', '1.05');
    });

    requestAnimationFrame(function () {
      setImportant(panel, 'min-height', Math.max(220, panel.scrollHeight) + 'px');
      if (cartContents && cartContents !== panel) {
        setImportant(cartContents, 'clear', 'both');
        setImportant(cartContents, 'position', 'relative');
        setImportant(cartContents, 'z-index', '1');
        setImportant(cartContents, 'margin-top', '12px');
      }
      if (followingBlock) {
        setImportant(followingBlock, 'clear', 'both');
        setImportant(followingBlock, 'position', 'relative');
        setImportant(followingBlock, 'z-index', '1');
        setImportant(followingBlock, 'margin-top', '12px');
      }
    });
  }

  function ensureRewardPanel(panel) {
    if (!panel) return null;
    if (!document.getElementById('tts-free-gift-panel-runtime-style')) {
      const style = document.createElement('style');
      style.id = 'tts-free-gift-panel-runtime-style';
      style.textContent = '.tts-free-gift-panel{display:flow-root!important;visibility:visible!important;opacity:1!important;height:auto!important;min-height:220px!important;background:#fffaf0!important;border:3px solid var(--tts-cart-ink,#074976)!important;border-radius:.45rem!important;box-shadow:4px 4px 0 var(--tts-cart-ink,#074976)!important;margin:.35rem 0 1.1rem!important;overflow:hidden!important;padding:.8rem!important;position:relative!important;z-index:2!important}.tts-free-gift-tier-grid{display:grid!important;visibility:visible!important;opacity:1!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:.45rem!important;margin-top:.65rem!important}.tts-free-gift-tier{display:grid!important;visibility:visible!important;opacity:1!important;background:#fff!important;border:2px solid var(--tts-cart-ink,#074976)!important;border-radius:.35rem!important;color:var(--tts-cart-ink,#074976)!important;gap:.12rem!important;min-height:4.65rem!important;padding:.46rem .36rem!important;text-align:center!important}.tts-free-gift-tier span,.tts-free-gift-tier strong,.tts-free-gift-tier em{display:block!important;color:inherit!important;font-style:normal!important;letter-spacing:0!important;line-height:1.08!important;margin:0!important}.tts-free-gift-tier span{font-size:.68rem!important;font-weight:900!important;text-transform:uppercase!important}.tts-free-gift-tier strong{font-size:1rem!important;font-weight:900!important}.tts-free-gift-tier em{font-size:.64rem!important;font-weight:800!important}.tts-free-gift-tier.is-unlocked{background:var(--tts-cart-ink,#074976)!important;border-color:var(--tts-cart-ink,#074976)!important;color:#fff!important}.tts-free-gift-tier.is-next{background:#fff4c8!important;border-color:var(--tts-cart-accent,#f4b63f)!important}.tts-free-gift-track{display:block!important;background:#fff!important;border:2px solid var(--tts-cart-ink,#074976)!important;border-radius:999px!important;height:.58rem!important;margin-top:.7rem!important;overflow:hidden!important}.tts-free-gift-track span{display:block!important;height:100%!important;background:linear-gradient(90deg,var(--tts-cart-red,#c8322d),var(--tts-cart-accent,#f4b63f))!important}@media screen and (min-width:641px){.tts-free-gift-panel{padding:1.05rem!important}.tts-free-gift-tier-grid{gap:.65rem!important}.tts-free-gift-tier{min-height:8.8rem!important;padding:1rem .55rem!important}.tts-free-gift-tier span{font-size:1.05rem!important}.tts-free-gift-tier strong{font-size:2rem!important}.tts-free-gift-tier em{font-size:.98rem!important}.tts-free-gift-track{height:.82rem!important}}@media screen and (max-width:640px){.tts-free-gift-panel{box-sizing:border-box!important;height:auto!important;min-height:220px!important;margin:.2rem 0 1.1rem!important;padding:.5rem!important;display:flow-root!important;overflow:hidden!important}.tts-free-gift-header{display:flex!important;align-items:flex-start!important;justify-content:space-between!important;gap:.45rem!important;margin-bottom:.4rem!important}.tts-free-gift-eyebrow{font-size:.72rem!important;max-width:38%!important}.tts-free-gift-message{font-size:.56rem!important;line-height:1.12!important;max-width:58%!important;text-align:right!important;margin-top:0!important}.tts-free-gift-tier-grid{box-sizing:border-box!important;display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:.28rem!important;min-height:0!important;position:static!important;width:100%!important}.tts-free-gift-tier{box-sizing:border-box!important;min-height:4.15rem!important;padding:.34rem .24rem!important}.tts-free-gift-tier span{font-size:.5rem!important}.tts-free-gift-tier strong{font-size:.78rem!important}.tts-free-gift-tier em{font-size:.5rem!important;line-height:1.05!important}.tts-free-gift-track{height:.45rem!important;margin-top:.45rem!important}}';
      (document.head || document.documentElement).appendChild(style);
    }

    let grid = panel.querySelector('.tts-free-gift-tier-grid');
    if (!grid || grid.querySelectorAll('[data-tts-free-gift-marker]').length < tiers.length) {
      if (grid) grid.remove();
      grid = document.createElement('div');
      grid.className = 'tts-free-gift-tier-grid';
      grid.setAttribute('aria-label', 'Free gift reward tiers');
      grid.innerHTML = tiers.map((tier, index) => '<div class="tts-free-gift-tier" data-tts-free-gift-marker data-variant-id="' + tier.variantId + '"><span>Tier ' + (index + 1) + '</span><strong>' + tier.label.replace('Spend ', '') + '</strong><em>' + tier.title + '</em></div>').join('');
      const header = panel.querySelector('.tts-free-gift-header');
      if (header) header.insertAdjacentElement('afterend', grid);
      else panel.insertBefore(grid, panel.firstChild);
    }

    let track = panel.querySelector('.tts-free-gift-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'tts-free-gift-track';
      track.setAttribute('aria-hidden', 'true');
      track.innerHTML = '<span data-tts-free-gift-fill></span>';
      panel.appendChild(track);
    }

    panel.style.display = 'block';
    panel.style.visibility = 'visible';
    panel.style.opacity = '1';
    grid.style.display = 'grid';
    grid.style.visibility = 'visible';
    grid.style.opacity = '1';
    keepMobileRewardPanelContained(panel);
    return panel;
  }

  function isGift(item) {
    return giftVariantIds.has(Number(item.variant_id));
  }

  function isBeybladeItem(item) {
    if (isGift(item)) return false;
    const haystack = [item.product_type, item.product_title, item.title, item.vendor, item.handle, item.url].filter(Boolean).join(' ').toLowerCase();
    return /bey\s*blade|takara tomy|hasbro beyblades|burst series|metal series|\bx series\b|beyblade x/.test(haystack);
  }

  function eligibleSubtotal(cart) {
    return cart.items.reduce((total, item) => isBeybladeItem(item) ? total + item.line_price : total, 0);
  }

  function renderProgress(cart) {
    const panel = ensureRewardPanel(document.querySelector('[data-tts-free-gifts]'));
    if (!panel) return;
    const subtotal = eligibleSubtotal(cart);
    const unlocked = tiers.filter((tier) => subtotal >= tier.threshold);
    const nextTier = tiers.find((tier) => subtotal < tier.threshold);
    const pct = Math.max(0, Math.min(100, subtotal / tiers[tiers.length - 1].threshold * 100));
    const message = panel.querySelector('[data-tts-free-gift-message]');
    const bar = panel.querySelector('[data-tts-free-gift-fill]');
    const markers = panel.querySelectorAll('[data-tts-free-gift-marker]');

    if (message) {
      if (nextTier) {
        const remaining = ((nextTier.threshold - subtotal) / 100).toFixed(2);
        message.textContent = '$' + remaining + ' in Beyblade items away from ' + nextTier.title + '.';
      } else {
        message.textContent = 'All Tyson\'s Toy Store rewards unlocked.';
      }
    }
    if (bar) bar.style.width = pct + '%';
    markers.forEach((marker) => {
      const variantId = Number(marker.getAttribute('data-variant-id'));
      marker.classList.toggle('is-unlocked', unlocked.some((tier) => tier.variantId === variantId));
    });
    keepMobileRewardPanelContained(panel);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    return response.json();
  }

  async function addGift(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _tts_free_gift: 'true' } })
    });
  }

  async function removeGift(item) {
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }

  async function refreshCartSections(cart) {
    const response = await fetch(window.location.pathname + '?sections=' + sectionIds, { credentials: 'same-origin' });
    const sections = await response.json();
    if (window.theme) window.theme.cartItemCount = cart.item_count;
    window.dispatchEvent(new CustomEvent('shapes:cart:update', { detail: { response: { sections: sections } } }));
  }

  async function syncFreeGifts() {
    if (syncing) return;
    syncing = true;
    try {
      let cart = await fetchCart();
      const subtotal = eligibleSubtotal(cart);
      let changed = false;

      for (const tier of tiers) {
        const item = cart.items.find((cartItem) => Number(cartItem.variant_id) === tier.variantId);
        const qualifies = subtotal >= tier.threshold;
        if (qualifies && !item) {
          await addGift(tier.variantId);
          changed = true;
        } else if (!qualifies && item) {
          await removeGift(item);
          changed = true;
        } else if (item && item.quantity !== 1) {
          await removeGift(item);
          await addGift(tier.variantId);
          changed = true;
        }
      }

      if (changed) cart = await fetchCart();
      renderProgress(cart);
      if (changed) await refreshCartSections(cart);
    } catch (error) {
      console.error('Tyson free gift sync failed', error);
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFreeGifts, 250);
  }

  document.addEventListener('DOMContentLoaded', function () { ensureRewardPanel(document.querySelector('[data-tts-free-gifts]')); scheduleSync(); });
  window.addEventListener('shapes:cart:afteradditem', scheduleSync);
  window.addEventListener('shapes:cart:cartqtychange', scheduleSync);
  window.addEventListener('shapes:cart:update', function () { setTimeout(function () { ensureRewardPanel(document.querySelector('[data-tts-free-gifts]')); scheduleSync(); }, 50); });
  document.addEventListener('theme:product:add', scheduleSync);
  document.addEventListener('theme:line-item:change', scheduleSync);
})();
